import { getCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { setMainNavigation } from "@insite/client-framework/Components/ShellHoleConnect";
import translate from "@insite/client-framework/Translate";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import { MainNavigationStyles } from "@insite/content-library/Widgets/Header/MainNavigation";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridWidths } from "@insite/mobius/GridItem";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { StyledIcon } from "@insite/mobius/Link";
import Menu from "@tCentro/MobiusOverrides/Menu";
import Modal from "@insite/mobius/Modal";
import Popover from "@insite/mobius/Popover";
import Typography from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import { NisMainNavigationStyles } from "@tCentro/Widgets/Header/NISMainNavigation";
import * as React from "react";
import { css, ThemeProps, withTheme } from "styled-components";
import postDatas from "@tCentro/Handlers/NISLoadHomePageCategoriesHandler";
import { connect, ResolveThunks } from "react-redux";

export interface MappedLink {
    title: string;
    url: string;
    type?: string;
    excludeFromNavigation?: boolean;
    openInNewWindow?: boolean;
    numberOfColumns?: number;
    numberOfColumnsCustom?: number;
    maxDepth?: number;
    childrenType?: "MegaMenu" | "CascadingMenu" | "CustomLinkList" | "CustomMegaMenu";
    children?: MappedLink[];
}
interface OwnProps {
    link: MappedLink;
    index: number;
    styles: NisMainNavigationStyles;
    container: React.RefObject<HTMLElement | null>;
    isOpen: boolean;
    displayChangeCustomerLink: boolean;
    isCustomMenuOpen?: boolean;
}
interface State {
    isModalOpen: boolean;
    cat?: any;
}
const mapDispatchToProps = {
    postDatas,
};
type Props = ThemeProps<BaseTheme> & OwnProps & HasHistory & ResolveThunks<typeof mapDispatchToProps>;

class NisMainNavigationItem extends React.Component<Props, State> {
    element = React.createRef<HTMLElement>();
    popover = React.createRef<any>();
    customPopover = React.createRef<any>();
    constructor(props: Props) {
        super(props);

        this.state = {
            isModalOpen: false,
            cat: [],
        };
    }
    componentDidMount(): void {
        if (this.props.link.childrenType === "CustomMegaMenu") {
            this.props.postDatas({
                onSuccess: result => {
                    const categories = (result as any).categories;
                    this.setState({ cat: categories });
                },
            });
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.openPopover();
        } else if (!this.props.isOpen && prevProps.isOpen) {
            this.closePopover();
        }
        if (this.props.isCustomMenuOpen && !prevProps.isCustomMenuOpen) {
            this.openCustomPopover();
        } else if (!this.props.isCustomMenuOpen && prevProps.isCustomMenuOpen) {
            this.customClosePopover();
        }
        setMainNavigation({
            close: () => {
                this.customPopover.current?.close();
            },
            openMenu: () => {
                this.customPopover.current?.open();
            },
        });
    }

    closePopover = () => {
        this.popover.current && (this.popover.current! as any).closePopover();
    };
    customClosePopover = () => {
        this.customPopover.current && (this.customPopover.current! as any).closePopover();
    };
    openCustomPopover = () => {
        this.customPopover.current && (this.customPopover.current! as any).openPopover();
    };
    openPopover = () => {
        this.popover.current && (this.popover.current! as any).openPopover();
    };
    openModal = () => {
        this.setState({ isModalOpen: true });
    };
    redirectToCategories = () => {
        this.props.history.push("/catalog");
    };

    render() {
        const {
            styles,
            link,
            index,
            isOpen,
            theme: {
                breakpoints: { maxWidths },
            },
        } = this.props;
        const downIcon = <StyledIcon src={ChevronDown} {...styles.menuItemIcon} />;
        const hasChildren = link.children && link.children.filter(child => !child.excludeFromNavigation).length > 0;
        const isCascading =
            hasChildren && (link.childrenType === "CascadingMenu" || link.childrenType === "CustomLinkList");
        const isMega = hasChildren && link.childrenType === "MegaMenu";
        const isCustomMenu = hasChildren && link.childrenType === "CustomMegaMenu";

        let menuLink = (
            <Link
                className="menu-item"
                typographyProps={styles.menuItemTypography}
                color={styles.menuItemTypography?.color}
                {...styles.menuItem}
                href={link.url}
                target={link.openInNewWindow ? "_blank" : ""}
            >
                {link.title}
                {isCascading && downIcon}
            </Link>
        );
        if (isMega || link.url === "") {
            menuLink = (
                <Link
                    className="menu-item"
                    typographyProps={styles.menuItemTypography}
                    color={styles.menuItemTypography?.color}
                    {...styles.menuItem}
                >
                    {link.title}
                    {(isCascading || isMega) && downIcon}
                </Link>
            );
        }
        if (isCustomMenu) {
            menuLink = (
                <>
                    <Popover
                        className="custom-modal"
                        zIndexKey="menu"
                        {...styles.megaMenuCustom}
                        controlsId="custom_modal"
                        popoverTrigger={menuLink} // dummy trigger since you control isOpen manually
                        contentBodyProps={{
                            as: "div",
                            css: css`
                                // padding: 20px 30px;
                                background-color: #f0f0f0 !important;
                                margin: 0px 32px !important;
                                padding: 40px;
                                max-width: 1762px;
                                left: 0px !important;
                                @media (min-width: 2400px) and (max-width: 7680px) {
                                    left: 20% !important;
                                }
                                @media (min-width: 4000px) and (max-width: 7680px) {
                                    left: 35% !important;
                                }
                            `,

                            ...styles.popoverContentBody,
                        }}
                        ref={this.customPopover}
                        insideRefs={[this.element]}
                    >
                        <StyledWrapper {...styles.megaMenuHeadingGridItem}>
                            <StyledWrapper>{translate("Product Categories")}</StyledWrapper>
                            <Button
                                className="custom-modal-button"
                                onClick={() => {
                                    this.redirectToCategories();
                                    this.customClosePopover();
                                }}
                                {...styles.megaMenuHeadingButton}
                            >
                                {translate("SHOP ALL PRODUCTS")}
                            </Button>
                        </StyledWrapper>

                        <GridContainer
                            className="mega-menu-custom-grid-container"
                            data-test-selector={`mainNavigationItem_${index}`}
                            {...styles.megaMenuGridContainerCustom}
                            offsetProps={{ ...styles.megaMenuGridContainerCustom?.offsetProps, as: "ul" }}
                        >
                            {Object.values(this.state.cat).map((cat: any) => {
                                return (
                                    <GridItem
                                        className="mega-menu-grid-item"
                                        width={(12 / link.numberOfColumnsCustom!) as GridWidths}
                                        key={index}
                                        {...styles.megaMenuGridItemCustom}
                                        as="li"
                                    >
                                        <Link href={cat.path} onClick={this.customClosePopover}>
                                            <LazyImage src={cat.smallImagePath} />
                                        </Link>
                                        <Link
                                            className="mega-menu-heading-link"
                                            {...styles.megaMenuHeadingCustom}
                                            href={cat.path}
                                            onClick={this.customClosePopover}
                                        >
                                            {cat.name}
                                        </Link>
                                    </GridItem>
                                );
                            })}
                        </GridContainer>
                    </Popover>
                </>
            );
        }

        let menuItem = menuLink;

        if (isCascading && link.children) {
            const menuProps: { maxDepth?: number } = {};
            if (link.maxDepth) {
                menuProps.maxDepth = link.maxDepth;
            }
            menuItem = (
                <Menu
                    className="cascading-menu"
                    data-test-selector={`mainNavigationItem_${index}`}
                    isOpen={isOpen || undefined}
                    descriptionId={`${link.title}_${index}`}
                    menuItems={link.children}
                    menuTrigger={menuLink}
                    displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                    {...menuProps}
                    {...styles.cascadingMenu}
                />
            );
        }
        if (isMega) {
            menuItem = (
                <Popover
                    className="mega-menu"
                    zIndexKey="menu"
                    {...styles.megaMenu}
                    contentBodyProps={{
                        ...styles.megaMenu?.contentBodyProps,
                        _width: 1140,
                        as: "div",
                    }}
                    controlsId={`${index}_${link.title}`}
                    ref={this.popover}
                    positionFunction={(element: React.RefObject<HTMLUListElement | null>) => {
                        if (this.props.container.current?.offsetParent) {
                            const parentPosition = this.props.container.current.getBoundingClientRect();
                            const rect = element.current?.getBoundingClientRect();
                            const top = rect ? rect.top + (rect.height > 100 ? styles.menuHeight : rect.height) : 0;
                            const cartWidth = 150;
                            const breakpointMaxWidth = maxWidths.find((value: number, index: number) => {
                                return (
                                    parentPosition.width + cartWidth <= value &&
                                    parentPosition.width + cartWidth > maxWidths[index - 1]
                                );
                            });

                            const width = breakpointMaxWidth ? breakpointMaxWidth - 30 : parentPosition.width;

                            return {
                                top,
                                position: "fixed",
                                left: parentPosition.left,
                                width: `${width}px`,
                            };
                        }
                        return { position: "absolute" };
                    }}
                    popoverTrigger={menuLink}
                    insideRefs={[this.element]}
                >
                    <GridContainer
                        className="mega-menu-grid-container"
                        data-test-selector={`mainNavigationItem_${index}`}
                        {...styles.megaMenuGridContainer}
                        offsetProps={{ ...styles.megaMenuGridContainer?.offsetProps, as: "ul" }}
                    >
                        {link
                            .children!.filter(child => !child.excludeFromNavigation)
                            .map((child, index) => (
                                <GridItem
                                    className="mega-menu-grid-item"
                                    width={(12 / link.numberOfColumns!) as GridWidths}
                                    key={index}
                                    {...styles.megaMenuGridItem}
                                    as="li"
                                >
                                    <Link
                                        className="mega-menu-heading-link"
                                        {...styles.megaMenuHeading}
                                        href={child.url}
                                        onClick={this.closePopover}
                                    >
                                        {child.title}
                                    </Link>
                                    {child.children && (
                                        <ul data-test-selector={`linksFor_${child.title}`}>
                                            {child.children
                                                .filter(grandChild => {
                                                    if (grandChild.excludeFromNavigation) {
                                                        return false;
                                                    }
                                                    if (
                                                        grandChild.type === "ChangeCustomerPage" &&
                                                        !this.props.displayChangeCustomerLink
                                                    ) {
                                                        return false;
                                                    }
                                                    if (grandChild.type === "VmiUsersPage") {
                                                        const currentMode = getCookie(NavigationModeCookieName);
                                                        if (!currentMode || currentMode === "Storefront") {
                                                            return false;
                                                        }
                                                    }

                                                    return true;
                                                })
                                                .map((grandChild, index) => (
                                                    <li key={index}>
                                                        <Link
                                                            className="mega-menu-link"
                                                            {...styles.megaMenuLink}
                                                            onClick={this.closePopover}
                                                            href={grandChild.url}
                                                            data-test-selector={grandChild.title}
                                                        >
                                                            {grandChild.title}
                                                        </Link>
                                                    </li>
                                                ))}
                                        </ul>
                                    )}
                                </GridItem>
                            ))}
                    </GridContainer>
                </Popover>
            );
        }

        return menuItem;
    }
}

export default connect(null, mapDispatchToProps)(withTheme(withHistory(NisMainNavigationItem)));
